export class ToggleTimeEntryApprovalAction {
  static readonly type = '[Project] Toggle Time Entry Approval';

  constructor(public id: string, public isApproved: boolean) {}
}
